
export default {
  common: {
    pageNotFound: 'Page non trouvée',
    backToHome: 'Retour à l\'accueil',
  },
  nav: {
    services: 'Services',
    pricing: 'Tarification',
    contact: 'Contact',
    getStarted: 'Commencer',
  },
  hero: {
    title: 'Transformez votre santé avec des conseils nutritionnels experts',
    subtitle: 'Plans nutritionnels personnalisés, suivi des macros et services de livraison de repas pour vous aider à atteindre vos objectifs de conditionnement physique plus rapidement et plus efficacement.',
    startJourney: 'Commencez votre parcours',
    learnMore: 'En savoir plus',
    imageAlt: 'Consultation nutritionnelle professionnelle',
    statsTitle: '1000+ histoires de succès',
    statsSubtitle: 'Clients transformés',
  },
  services: {
    title: 'Nos services',
    subtitle: 'Solutions complètes de nutrition et de conditionnement physique adaptées à vos besoins et objectifs uniques.',
    nutrition: {
      title: 'Consultation nutritionnelle',
      description: 'Obtenez des plans nutritionnels personnalisés de nutritionnistes certifiés basés sur vos objectifs, préférences et style de vie.',
      feature1: 'Consultations individuelles',
      feature2: 'Plans de repas personnalisés',
      feature3: 'Support de clavardage 24/7',
    },
    tracking: {
      title: 'Suivi des macros',
      description: 'Outils de suivi avancés pour surveiller vos macronutriments, calories et progrès vers vos objectifs de mise en forme.',
      feature1: 'Suivi des macros en temps réel',
      feature2: 'Analyses de progrès',
      feature3: 'Ajustements d\'objectifs',
    },
    delivery: {
      title: 'Livraison de repas',
      description: 'Repas frais et pré-portionnés livrés à votre porte, parfaitement alignés avec votre plan nutritionnel.',
      feature1: 'Ingrédients frais quotidiens',
      feature2: 'Portions personnalisables',
      feature3: 'Horaire flexible',
    },
  },
  pricing: {
    title: 'Choisissez votre plan',
    subtitle: 'Sélectionnez le plan parfait pour commencer votre parcours de transformation. Tous les plans incluent nos fonctionnalités de base avec différents niveaux de support.',
    popular: 'Le plus populaire',
    getStarted: 'Commencer',
    basic: {
      name: 'Plan de base',
      period: 'mois',
      description: 'Parfait pour les débutants qui commencent leur parcours de mise en forme',
      feature1: 'Consultation nutritionnelle de base',
      feature2: 'Plans de repas hebdomadaires',
      feature3: 'Support par courriel',
      feature4: 'Accès à l\'application mobile',
    },
    pro: {
      name: 'Plan Pro',
      period: 'mois',
      description: 'Idéal pour les passionnés sérieux de conditionnement physique',
      feature1: 'Consultation nutritionnelle avancée',
      feature2: 'Plans de repas quotidiens',
      feature3: 'Support de clavardage prioritaire',
      feature4: 'Outils de suivi des macros',
      feature5: 'Analyses de progrès',
    },
    elite: {
      name: 'Plan Élite',
      period: 'mois',
      description: 'Package de transformation complète',
      feature1: 'Consultation nutritionnelle premium',
      feature2: 'Livraison de repas personnalisée',
      feature3: 'Support téléphonique 24/7',
      feature4: 'Suite de suivi avancée',
      feature5: 'Coach nutritionnel personnel',
      feature6: 'Recommandations de suppléments',
    },
  },
  contact: {
    title: 'Prêt à commencer votre transformation?',
    subtitle: 'Contactez nos experts en nutrition et faites le premier pas vers une version plus saine de vous-même.',
    phone: 'Téléphone',
    email: 'Courriel',
    address: 'Adresse',
    form: {
      name: 'Nom complet',
      namePlaceholder: 'Entrez votre nom complet',
      email: 'Adresse courriel',
      emailPlaceholder: 'Entrez votre adresse courriel',
      phone: 'Numéro de téléphone',
      phonePlaceholder: 'Entrez votre numéro de téléphone',
      goal: 'Objectif de mise en forme',
      goalPlaceholder: 'Sélectionnez votre objectif principal',
      goals: {
        weightLoss: 'Perte de poids',
        muscleGain: 'Gain musculaire',
        maintenance: 'Maintien du poids',
        performance: 'Performance athlétique',
      },
      message: 'Message',
      messagePlaceholder: 'Parlez-nous de votre situation actuelle et de vos objectifs...',
      charactersRemaining: 'caractères restants',
      submit: 'Envoyer le message',
      sending: 'Envoi en cours...',
      successMessage: 'Merci! Votre message a été envoyé avec succès. Nous vous répondrons dans les 24 heures.',
      errorMessage: 'Désolé, il y a eu une erreur lors de l\'envoi de votre message. Veuillez réessayer ou nous contacter directement.',
    },
  },
  footer: {
    description: 'Donner aux individus les moyens d\'atteindre leurs objectifs de santé et de conditionnement physique grâce à des conseils nutritionnels personnalisés et des solutions de bien-être complètes.',
    services: 'Services',
    nutritionConsulting: 'Consultation nutritionnelle',
    macroTracking: 'Suivi des macros',
    mealDelivery: 'Livraison de repas',
    personalTraining: 'Entraînement personnel',
    company: 'Entreprise',
    aboutUs: 'À propos de nous',
    careers: 'Carrières',
    privacy: 'Politique de confidentialité',
    terms: 'Conditions de service',
    copyright: 'Tous droits réservés.',
  },
};
